{
  "COMMON": {
    "SAVE": "Save",
    "SAVE_AND_CONTINUE": "Save and continue",
    "NEXT": "Next",
    "BACK": "Back",
    "EDIT": "Edit",
    "CANCEL": "Cancel",
    "CLOSE": "Close",
    "DELETE": "Delete",
    "INVALID_FORM": "Form is invalid",
    "ERROR_OCCURRED": "An error occurred",
    "YES": "Yes",
    "NO": "No",
    "NO_RESULTS": "No results",
    "RETRY": "Retry",
    "UPLOADING": "Uploading..."
  },
  "AI_KNOWLEDGE_BASE": "AI knowledge base",
  "MANAGE_KNOWLEDGE": "Manage knowledge",
  "MANAGE_KNOWLEDGE_DESCRIPTION": "Provide information AI can use when creating content or answering inquiries",
  "REFRESH_OPTIONS": "Refresh options",
  "KNOWLEDGE_SOURCES": "Knowledge sources",
  "ADD_KNOWLEDGE": "Add knowledge",
  "ADD_NEW_KNOWLEDGE": "+ Add new knowledge",
  "SELECT_KNOWLEDGE": "Select knowledge",
  "APPLICATION_SETTINGS": "Settings",
  "APPS_WARNING": "This knowledge will be removed from the following:",
  "NO_APPS": "This knowledge is not currently being used.",
  "NO_MATCHING_KNOWLEDGE_SOURCES": "No knowledge available",
  "SUGGESTED": "Suggested",
  "WEBSITE_SCRAPE": {
    "SCRAPE_NOT_DONE": "Finding pages...",
    "TRAINING_NOT_DONE": "Training pages...",
    "LAST_SCRAPED": "Last refreshed {{lastScraped}}",
    "NUMBER_OF_PAGES_TRAINED": "Trained on {{trainedPagesCount}} of {{scrapedPagesCount}} pages",
    "RESCRAPE": "Refresh",
    "RESCRAPE_PAGES": "Refresh pages",
    "RESCRAPE_ALL_PAGES": "Refresh all pages",
    "RESCRAPE_CONFIRMATION": {
      "TITLE": "Refresh this website?",
      "MESSAGE": "This will update the content from the website. Pages found previously will be replaced.",
      "MESSAGE_LOSE_CHANGES": "Any unsaved changes will be lost"
    },
    "EXCLUDED_PATHS": {
      "TITLE": "Excluded paths",
      "DESCRIPTION": "URLs that contain these paths will be skipped."
    },
    "ENABLE_AUTOMATIC_RESCRAPE": "Enable automatic refresh",
    "AUTOMATIC_RESCRAPE_ENABLED": "Refreshes automatically on {{date}}",
    "TRAINING_IN_PROGRESS_TOOLTIP": "Training is still in progress. Knowledge will be available to assistants after training is complete.",
    "DISABLE": "Disable",
    "ERRORS": {
      "TITLE": "Unable to find pages for {{ url }}",
      "ERROR": "You can go back and change it or try again if this looks correct",
      "SITEMAP_INDIRECT": "Did not find a sitemap (.xml or robots.txt) at {{ url }}. Provide a direct URL to the sitemap or try a different method.",
      "ACTIONS": {
        "TRY_AGAIN": "Try again",
        "GO_BACK": "Go back"
      },
      "DESCRIPTION": "Failed to find page"
    }
  },
  "EDIT_KNOWLEDGE": {
    "TITLE": "Edit knowledge",
    "NAME": "Name",
    "CUSTOM_DATA_CONFIG": {
      "TITLE": "Text",
      "DESCRIPTION": "Content related to your business such as FAQs or custom information",
      "CONTENT": "Content",
      "CONTENT_HINT": "Provide frequently asked questions and answers or other text the AI can use in responses. This does not give special instructions to AI"
    },
    "WEBSITE_SCRAPE_CONFIG": {
      "TITLE": "Website",
      "DESCRIPTION": "Retrieve content from a website",
      "URL": "URL",
      "INVALID_URL": "Please enter a valid URL",
      "CRAWL_MODE": "Mode",
      "SINGLE_PAGE": "Single page",
      "FOLLOW_LINKS": "Follow links",
      "FOLLOW_LINKS_HINT": "Will find up to {{pageLimit}} pages by following links from this domain starting on the provided URL",
      "SITEMAP": "Sitemap",
      "SITEMAP_HINT": "Uses sitemap (.xml or robots.txt) to find up to {{pageLimit}} pages. You may optionally provide the sitemap URL, or we'll try to find it on the provided URL",
      "URL_HINT": "The URL must be publicly accessible. A URL is publicly accessible if you can access it in incognito mode (in Chrome) or private browsing mode (in Safari/Firefox) without logging in.",
      "PAGES": "Pages",
      "NUMBER_OF_PAGES_TRAINED": "Trained on {{trainedPagesCount}} of {{scrapedPagesCount}} pages",
      "SELECT_PAGES_TO_TRAIN": "Choose pages to train on:",
      "SELECT_PAGES_TO_REFRESH": "Choose pages to refresh:",
      "SELECT_ALL": "Select all",
      "SELECT_NONE": "Select none",
      "PAGE_COUNT": "Pages: {{scrapedPagesCount}}",
      "PAGES_SELECTED": "{{selectedPagesCount}} selected",
      "UNABLE_TO_LOAD": "Unable to load",
      "SCRAPE_WILL_BE_QUEUED": "Knowledge will be retrieved after widget is created",
      "SCRAPE_QUEUED": "Finding pages...",
      "SCRAPE_IN_PROGRESS": "Pages found: ",
      "SCRAPE_IN_PROGRESS_CLARIFICATION_DEFAULT": "This may take a few minutes. Pages will appear here when done. You can close this panel and continue later without losing progress.",
      "REFRESH": "Refresh",
      "PAGE_TITLE": "Page title",
      "FIND_PAGES": "Find pages",
      "TRAIN": "Train",
      "MY_WEBSITE": "My Website"
    },
    "FILE_UPLOAD_CONFIG": {
      "TITLE": "File Upload",
      "DESCRIPTION": "Upload a document or file to provide as knowledge",
      "UPLOAD_FILES": "Upload file",
      "SELECT_FILE": "Select file to upload",
      "NAME_PLACEHOLDER": "Will be auto-filled from file name",
      "HINT_TEXT": "Supported formats: PDF, DOCX, HTML, Images (JPG, PNG), TXT, CSV, Markdown, JSON, PowerPoint (PPTX), Excel (XLS, XLSX) (max 100MB)",
      "DRAG_DROP_SINGULAR": "Drag and drop a file here",
      "CHOOSE_FILE_SINGULAR": "Choose file",
      "UPLOADED_FILE": "Uploaded file",
      "CURRENT_FILE": "Current file",
      "VIEW_FILE": "View file",
      "DOWNLOAD_FILE": "Download file",
      "UPLOAD_NEW_TO_REPLACE": "Upload a new file to replace the current one",
      "UPLOAD_SUCCESS": "File uploaded successfully",
      "UPLOAD_ERROR": "File upload failed",
      "FILE_REPLACED": "File replaced successfully",
      "NO_FILE_UPLOADED": "Please upload a file",
      "UPLOAD_PROCESSING": "Please wait for file processing to complete"
    },
    "TRAINING": {
      "TRAINING_QUEUED": "Training queued",
      "TRAINING_IN_PROGRESS": "Pages trained: ",
      "TRAINING_IN_PROGRESS_CLARIFICATION": "This may take a few minutes. After training, select where to use the new knowledge. You can close this panel and continue later.",
      "INITIAL_TRAINING": "This training was automatically started for you. It will train the main page for the provided URL. You can add more pages when this is done."
    },
    "REQUIRED_FIELD": "Required",
    "FIELD_REQUIRED": "This field is required",
    "ENTER_KNOWLEDGE": "Enter knowledge",
    "ADD_TO_AI": "Add to AI",
    "SUCCESSFULLY_SAVED": "Knowledge saved",
    "OTHER_AI": "Changes made here will also apply to {{count}} other AI"
  },
  "DELETE_KNOWLEDGE": {
    "TITLE": "Delete custom knowledge?",
    "SUCCESSFULLY_DELETED": "Knowledge deleted"
  },
  "APPLICATION_SELECTOR": {
    "NO_APPS_TITLE": "Create your first AI enabled application",
    "NO_APPS_BODY": "A Web Chat widget can use this knowledge to answer inquires from visitors on your website.",
    "CREATE_WIDGET": "Create widget",
    "ADD_KNOWLEDGE_TO": "Add knowledge to:",
    "PLACEHOLDER": "Choose applications..."
  },
  "BUSINESS_PROFILE": {
    "SHARE_FIELDS": "Share Business Profile fields with your AI assistant",
    "SHARE_FIELDS_TOOLTIP": "Information shared: business name, address and/or service areas, website, email, phone number, categories, hours, services offered, short description, long description, social media URLs, and booking URL.",
    "BUSINESS_PROFILE": "Business Profile",
    "ALLOW_ACCESS": "Allow access to your business profile",
    "DESCRIPTION": "Answer questions about your business contact information, hours, products and services you offer.",
    "MANAGE_BUSINESS_PROFILE": "Manage business profile"
  },
  "UNSAVED_CHANGES": {
    "TITLE": "Unsaved changes",
    "MESSAGE": "Are you sure you want to leave? You will lose any unsaved changes."
  },
  "CREATE_WEB_CHAT_WIDGET": {
    "LOADING_DESCRIPTION": "Creating web chat widget...",
    "SUCCESS": {
      "TITLE": "Web chat widget successfully created",
      "KEEP_EDITING": "Keep editing",
      "GO_TO_WEB_CHAT_SETTINGS": "Go to web chat settings"
    },
    "ERROR": {
      "TITLE": "An error occurred while creating the web chat widget",
      "MESSAGE": "Try again?",
      "YES": "Retry create widget"
    },
    "NO_WEB_CHAT_WIDGET": {
      "TITLE": "There are no Web Chat widgets to add this knowledge to",
      "BODY": "Would you like to create one now?",
      "YES": "Yes, create widget"
    }
  }
}
